import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { BaseUrl } from "../../../../redux/config";
import axios from "axios";
import { getSession } from "../../../../redux/actions/authActions";
import "./Patient.scss";
import commObj from "../../../../constants/Common";
import PaymentSuccessModal from "../../../../Modals/PaymentSuccessModal";
import PaymentFailedModal from "../../../../Modals/PaymentFailedModal";
import { CustomCard } from "../../../CustomCard";
import TextAreaModal from "../../../../Modals/TextAreaModal";
import { toast } from "react-toastify";
import { getProfileSession } from "../../../../redux/actions/dbactions/profileActions";
import { Icon } from "@iconify/react/dist/iconify.js";

export const PatientCard = ({
  data,
  currentData,
  bookingData,
  handleSubmitPay,
  paymentInitialised = false,
}) => {
  const { user_profile_id, role_id } = getSession();
  const { profileData } = getProfileSession();

  const [url, setUrl] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [loading, setIsLoading] = useState(false);
  const [showTextArea, setShowTextArea] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("stripe");
  const [paymentType, setPaymentType] = useState("full");
  const [partialAmount, setPartialAmount] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [failedModalShow, setFailedModalShow] = useState(false);
  const [isSharedPayment, setIsSharedPayment] = useState(false);

  const {
    svcuser_profile_id,
    user_first_name,
    user_phone_nbr,
    user_last_name,
    user_iso_cntry_cde,
    user_iso_city_name,
    addr_street1,
  } = data;
  const { svc_id, svc_name, svc_cost_amt, svc_svcf_id } = currentData;
  const { ord_svc_date, ord_svc_time } = bookingData || {};

  const isInsufficientBalance =
    paymentType !== "partial" && profileData?.wallet_balance < svc_cost_amt;

  useEffect(() => {
    if (url) {
      window.location.href = url;
    }
  }, [url]);

  const handleSubmit = async () => {
    const { token } = getSession();
    setIsLoading(true);

    try {
      const postData = {
        ord_svc_date,
        ord_svc_time,
        order_dte_tsp: "2022-07-15T12:00:00Z",
        order_tot_amt: svc_cost_amt,
        order_tot_tax: 0.0,
        order_tot_fees: 0.0,
        order_svcf_id: svc_svcf_id,
        user_profile_id,
        order_svc_user_id: svcuser_profile_id,
        order_ship_to_id: 2,
        order_ship_instructions: inputValue || "",
        order_bill_to_id: 2,
        order_status_id: 1,
        sys_user_id: user_profile_id,
        role_id,
        sys_source_ip: "192.168.2.2",
        sys_crte_tsp: "2022-07-15T12:00:00Z",
        sys_last_updte_tsp: "2022-07-15T12:30:00Z",
        sys_ord_active_yn: "Y",
        payment_method: paymentMethod,
        payment_mode: paymentType,
        service_order_line: [
          {
            svc_id,
            svc_name,
            svc_qnty_nbr: 1,
            svc_status_id: 1,
            svc_price_amt: svc_cost_amt,
            svcfee_id: 1,
            sys_user_id: user_profile_id,
            sys_ordl_active_yn: "Y",
            sys_crte_tsp: "2022-07-15T12:00:00Z",
            sys_last_updte_tsp: "2022-07-15T12:30:00Z",
          },
        ],
      };

      if (paymentType === "partial") {
        if (partialAmount <= 0) {
          toast.dismiss();
          toast.error("Amount must be more than 0");
          return;
        }
        postData.order_payment_amt = partialAmount;
      }
      if (isSharedPayment) {
        postData.create_share_payment_link = true;
      }

      let response = await axios.post(`${BaseUrl}pay/ps`, postData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (paymentMethod === "wallet") {
        setUrl("/health/dashboard?payment_status=success");
      }
      setUrl(response.data.session_url);
      return response.data;
    } catch (err) {
      if (paymentMethod === "wallet") {
        setUrl("/health/dashboard?payment_status=failed");
        return;
      }
      toast.error(
        `${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
      if (err.response?.data?.session_url) {
        setUrl(err.response?.data?.session_url);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const user_phone_nbrf = commObj.formatPhoneNumber(user_phone_nbr, "ZW");

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handlePartialAmountChange = (e) => {
    const value = e.target.value;
    if (!isNaN(value) && value >= 0) {
      if (Number(value) > svc_cost_amt) {
        setPartialAmount(svc_cost_amt);
      } else {
        setPartialAmount(value);
      }
    }
  };

  return (
    <div>
      <CustomCard className="facility patient-card">
        <div
          className="d-flex justify-content-between align-items-center !pb-3 !mb-4"
          style={{ borderBottom: "1px solid #E7E7E9" }}
        >
          <div className="d-flex align-items-center justify-content-center gap-2">
            <div>
              <h6 className="card-title mb-0">{`${user_first_name} ${user_last_name}`}</h6>
              <small>#{svcuser_profile_id}</small>
            </div>
          </div>
        </div>

        <div className="row gap-y-[18px]">
          <div className="col-6">
            <small>Mobile No:</small>
            <p className="truncate mb-0">{user_phone_nbrf}</p>
          </div>
          <div className="col-6">
            <small>Address:</small>
            <p className="truncate mb-0">{addr_street1}</p>
          </div>
          <div className="col-6">
            <small>City Name:</small>
            <p className="truncate mb-0">{user_iso_city_name}</p>
          </div>
          <div className="col-6">
            <small>Country:</small>
            <p className="truncate mb-0">{user_iso_cntry_cde}</p>
          </div>
        </div>

        <div className="mt-6">
          <div className="mb-3">
            <div className="flex justify-between gap-4 items-center">
              <label className="flex items-center gap-1 cursor-pointer">
                <input
                  disabled={loading || paymentInitialised}
                  type="checkbox"
                  name={`paymentMethod_${svcuser_profile_id}`}
                  value="partial"
                  checked={paymentType === "partial"}
                  onChange={({ target }) => {
                    const { checked } = target;
                    if (!checked) {
                      setPartialAmount(0);
                    }
                    setPaymentType(checked ? "partial" : "full");
                  }}
                />
                Pay Partially
              </label>
            </div>

            {paymentType === "partial" && (
              <div className="mt-2">
                <input
                  disabled={loading || paymentInitialised}
                  type="number"
                  className="form-control border p-2 w-full rounded-md"
                  placeholder="Enter amount"
                  value={partialAmount}
                  onChange={handlePartialAmountChange}
                />
              </div>
            )}
          </div>
          {paymentType === "partial" ? (
            <label className="flex items-center gap-1 cursor-pointer my-3">
              <input
                disabled={paymentInitialised}
                type="checkbox"
                name={`paymentMethod_${svcuser_profile_id}`}
                value="partial"
                checked={isSharedPayment}
                onChange={({ target }) => {
                  setIsSharedPayment(target.checked);
                }}
              />
              Share Payment
            </label>
          ) : null}
          <div className="flex flex-col gap-2 justify-center items-center">
            <div className="flex flex-col items-center w-full text-center">
              <label
                className={`flex items-center gap-1 w-full rounded-md border text-sm justify-center p-[12px] ${
                  paymentMethod === "stripe"
                    ? "border-blue-500"
                    : "border-gray-300"
                }`}
              >
                <input
                  disabled={paymentInitialised}
                  type="radio"
                  name={`paymentMethod_${svcuser_profile_id}`}
                  value="stripe"
                  checked={paymentMethod === "stripe"}
                  onChange={() => setPaymentMethod("stripe")}
                />
                Credit/Debit Card
              </label>
            </div>
            <div className="flex flex-col items-center w-full text-center">
              <label
                className={`flex items-center gap-1 w-full rounded-md border text-sm justify-center p-2  ${
                  isInsufficientBalance
                    ? "cursor-not-allowed !text-[#769895] bg-gray-200"
                    : "bg-white border-gray-300"
                }`}
              >
                <input
                  disabled={isInsufficientBalance || paymentInitialised}
                  type="radio"
                  name={`paymentMethod_${svcuser_profile_id}`}
                  value="wallet"
                  checked={paymentMethod === "wallet"}
                  onChange={() => setPaymentMethod("wallet")}
                />
                <Icon
                  icon="material-symbols-light:account-balance-wallet-outline"
                  className="size-6"
                />
                E-Wallet{" "}
                {isInsufficientBalance && (
                  <p className="!text-[#769895] !text-xs m-0">
                    (Insufficient Balance)
                  </p>
                )}
              </label>
              <p className="!text-green-600 !text-xs font-semibold mt-1">
                Get 5% discount on paying via Wallet!
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-end relative mt-1">
          <div className="flex gap-3 w-full justify-between">
            <button
              disabled={loading || paymentInitialised}
              className="sign_btn !w-full !text-xs"
              style={{ boxSizing: "border-box" }}
              onClick={() => handleSubmitPay(paymentMethod, partialAmount)}
            >
              <p className="!m-0 text-white !p-0">Checkout</p>
            </button>

            {role_id === 1 && (
              <button
                className="sign_btn !w-full !text-xs"
                onClick={handleSubmit}
              >
                {loading ? (
                  <Spinner animation="border" variant="white" />
                ) : (
                  <b>Donor Order</b>
                )}
              </button>
            )}
          </div>
        </div>
      </CustomCard>
      <TextAreaModal
        show={showTextArea}
        onHide={() => setShowTextArea(false)}
        value={inputValue}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
        loading={loading}
      />
      <PaymentSuccessModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <PaymentFailedModal
        show={failedModalShow}
        onHide={() => setFailedModalShow(false)}
      />
    </div>
  );
};
